// src/pages/AllUsers.jsx
import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import '../styles/AllProducts.css'; // Reusing the same premium table CSS

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      // Direct API call using our central client
      const response = await apiClient.get('/admin/users/all');
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  // Search filter logic (Search by phone or name)
  const filteredUsers = users.filter((user) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (user.name && user.name.toLowerCase().includes(searchLower)) ||
      (user.phoneNumber && user.phoneNumber.includes(searchLower))
    );
  });

  // Format date to look readable (e.g., 24 Mar 2026)
  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-IN', options);
  };

  return (
    <div className="admin-products-container">
      
      {/* HEADER */}
      <div className="admin-header">
        <div>
          <h2 className="admin-title">Customer Management</h2>
          <p className="admin-subtitle">View and manage all registered users on the platform.</p>
        </div>
      </div>

      {/* SEARCH BAR */}
      <div className="filters-container" style={{ gridTemplateColumns: '1fr' }}>
        <input 
          type="text" 
          className="filter-input" 
          placeholder="🔍 Search by phone number or name..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* TABLE SECTION */}
      <div className="table-wrapper">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px', color: '#64748B', fontWeight: 'bold' }}>
            Loading Customer Data...
          </div>
        ) : filteredUsers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '50px', color: '#94A3B8' }}>
            <h2>No Customers Found</h2>
            <p>We couldn't find any users matching your search.</p>
          </div>
        ) : (
          <table className="modern-table">
            <thead>
              <tr>
                <th>Customer Details</th>
                <th>Contact Info</th>
                <th>Profile Status</th>
                <th>Joined Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr key={user._id}>
                  
                  {/* Name & Avatar */}
                  <td>
                    <div className="vendor-info">
                      <div className="vendor-avatar" style={{ backgroundColor: '#EEF2FF', color: '#4F46E5' }}>
                        {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                      </div>
                      <div>
                        <div className="vendor-name">{user.name || "Guest User"}</div>
                        <div className="vendor-sub">App Customer</div>
                      </div>
                    </div>
                  </td>
                  
                  {/* Contact */}
                  <td>
                    <div style={{ color: '#0F172A', fontWeight: '700' }}>+91 {user.phoneNumber}</div>
                    <div className="vendor-sub">{user.email || "No Email Provided"}</div>
                  </td>

                  {/* Profile Status */}
                  <td>
                    {user.isProfileComplete ? (
                      <span className="status-badge" style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}>
                        ✅ Profile Complete
                      </span>
                    ) : (
                      <span className="status-badge" style={{ backgroundColor: '#FEF3C7', color: '#D97706' }}>
                        ⏳ Missing Details
                      </span>
                    )}
                  </td>

                  {/* Joined Date */}
                  <td>
                    <div style={{ color: '#475569', fontWeight: '600' }}>
                      {formatDate(user.createdAt)}
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
};

export default AllUsers;